import { SortingState } from '@tanstack/react-table';

import { SortOrder } from '@/shared/constants/sort-order.constant';

import { SortChangePayload } from './table.types';

export const getSortingState = (fallback: SortingState, sort?: SortChangePayload): SortingState => {
	if (!sort) {
		return fallback;
	}

	if (!sort.field || !sort.direction) {
		return [];
	}

	return [{ id: sort.field, desc: sort.direction === SortOrder.DESC }];
};
